import { Link, Navigate } from "react-router-dom";
import { BUSINESS_QUALITY } from "../data/businessQuality";
import { BUSINESS_MEDIA } from "../data/businessMedia";
import { useAdminAuth } from "@/hooks/useAdminAuth";

export default function BusinessAccuracy() {
  const { checking, revealAdminUi } = useAdminAuth();
  if (checking) return null;
  if (!revealAdminUi) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#F8FAFC] px-4 py-12 text-[#0F172A]">
      <main className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#059669]">Internal quality control</p>
            <h1 className="mt-2 text-3xl font-bold font-display">PH Business Accuracy Dashboard</h1>
            <p className="mt-3 max-w-3xl text-sm leading-6 text-[#475569]">
              Tracks the factual-review date and media status for every active jewelry, dental, construction, real-estate and event concept. “Checked” means compared with the supplied dossier; it does not replace direct confirmation by the business.
            </p>
          </div>
          <Link to="/ph" className="text-sm font-semibold text-[#047857] hover:underline">Back to MySiteCare PH</Link>
        </div>

        <div className="mt-8 overflow-x-auto rounded-2xl border border-[#E2E8F0] bg-white shadow-sm">
          <table className="w-full min-w-[900px] text-left text-sm">
            <caption className="sr-only">Accuracy status for all PH business concepts</caption>
            <thead className="bg-[#F1F5F9] text-xs uppercase tracking-wide text-[#475569]">
              <tr><th className="px-5 py-4">Business</th><th className="px-5 py-4">Category</th><th className="px-5 py-4">Location</th><th className="px-5 py-4">Checked</th><th className="px-5 py-4">Additional media</th><th className="px-5 py-4">Status</th></tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]">
              {BUSINESS_QUALITY.map(item => {
                const media = BUSINESS_MEDIA[item.path];
                return (
                  <tr key={item.path} className="hover:bg-[#F8FAFC]">
                    <td className="px-5 py-4"><a className="font-semibold text-[#0F766E] hover:underline" href={item.path}>{item.name}</a><div className="mt-1 text-xs text-[#94A3B8]">{item.path}</div></td>
                    <td className="px-5 py-4">{item.category}</td>
                    <td className="px-5 py-4">{item.locality}</td>
                    <td className="px-5 py-4 whitespace-nowrap">Aug. 20, 2026</td>
                    <td className="px-5 py-4">{media ? `${media.count} deduplicated images` : item.mediaStatus}</td>
                    <td className="px-5 py-4"><span className="inline-flex rounded-full bg-[#DCFCE7] px-2.5 py-1 text-xs font-semibold text-[#166534]">Research-backed concept</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
